import React from 'react';
import { Spinner, Margin, QuickAction, PageIndicatorInfo } from '@scotia/canvas-react';
import PropTypes from 'prop-types';
import { Tag } from '@cldf/scotiaweb-gtm';
import MarketingBanner from 'advertising-web-cl';
import { MercuryZone } from 'mercury-react-sdk';
import { Constants } from '../../../../../constants/Constants';
import styles from '../../ProductSummary.scss';
import ErrorComponent from '../../../../error';
import { renderIcon } from './utils';

export const componentExists = component => component.type !== undefined;

export const doElementContainsSomething = (element = null, exclude = null) => {
  if (element) {
    let exist = false;
    if (Array.isArray(element)) {
      exist = element.length > 0;
    } else if (typeof element === 'object') {
      const obj = element;
      Object.keys(obj).forEach(key => {
        if (
          obj[key] &&
          obj[key].length > 0 &&
          (exclude == null || exclude.length !== 0 || exclude.indexOf(key) === -1)
        ) {
          exist = true;
        }
      });
    }
    return exist;
  }
  return false;
};

export const mapDataId = id => {
  switch (id) {
    case 'ACCOUNTS':
      return {
        dataIde: 'cuentas',
        dataName: 'obten tu cuenta renta diaria',
      };
    case 'CARDS':
      return {
        dataIde: 'tarjetas',
        dataName: 'obten tu avance en cuotas',
      };
    case 'CREDITS':
      return {
        dataIde: 'creditos',
        dataName: 'pide tu credito de consumo',
      };
    case 'INVESTMENTS':
      return {
        dataIde: 'inversiones',
        dataName: 'invierte en un deposito a plazo',
      };
    default:
      return {
        dataIde: 'productos',
        dataName: 'mas productos',
      };
  }
};

export const marketingBannerExists = () =>
  componentExists(<MarketingBanner />) || console.error('MarketingBanner does not exists.');

/**
 *
 * Content for rehuse in multiple products
 */
const ContentContainer = ({
  id,
  error,
  loading,
  children,
  action,
  exclude,
  newProductMessage,
  newProductAction,
  banner = null,
  mercury,
}) => (
  <div>
    {!error ? (
      <div>
        {!loading ? (
          <div>
            {banner && marketingBannerExists() && (
              <Margin md={24} xs={24} sm={24} lg={24} side="top">
                <Margin md={20} xs={20} sm={20} lg={20} side="bottom">
                  <MarketingBanner api={banner.api} color={banner.color} promotions={banner.promotions} />
                </Margin>
              </Margin>
            )}
            {doElementContainsSomething(children.props.list, exclude) ? <div>{children}</div> : <InfoNoProducts />}
            {newProductAction && newProductMessage && (
              <NewProduct
                message={newProductMessage}
                action={newProductAction}
                className="impfollow clickfollow"
                icon={() => renderIcon(id)}
                {...mapDataId(id)}
                dataCreative="mas productos home"
                dataPosition="1"
              />
            )}
            {mercury && mercury.zoneId && (
              <Margin md={24} xs={24} sm={24} lg={24} side="top">
                <MercuryZone id={mercury.zoneId} />
              </Margin>
            )}
          </div>
        ) : (
          <Spinner color={'highlight'} size={24} />
        )}
      </div>
    ) : (
      <div style={{ paddingTop: '20px' }}>
        <ErrorComponent actionClick={action} error={error} />
      </div>
    )}
  </div>
);

export const NewProduct = ({ message, action, icon, dataIde, dataName, dataCreative, dataPosition, className }) => (
  <Tag
    className={className}
    data-ide={dataIde}
    data-name={dataName}
    data-creative={dataCreative}
    data-position={dataPosition}
  >
    <Margin side={'top'} lg={24} md={24} sm={12} xs={6}>
      <QuickAction id="test-id" className={styles['product-width-new']} Icon={icon} onClick={action}>
        {message}
      </QuickAction>
    </Margin>
  </Tag>
);

export const InfoNoProducts = () => (
  <div className="nice-padding" style={{ paddingTop: '20px' }}>
    <PageIndicatorInfo message={Constants.infoNoProduct} />
  </div>
);

ContentContainer.propTypes = {
  exclude: PropTypes.array,
  error: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  hasProduct: PropTypes.bool,
  newProductMessage: PropTypes.string,
  newProductAction: PropTypes.func,
  banner: PropTypes.shape({
    api: PropTypes.string,
    color: PropTypes.string,
    promotions: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      creative: PropTypes.string,
      position: PropTypes.string,
    }),
  }),
  mercury: PropTypes.shape({
    zoneId: PropTypes.string,
  }),
};

ContentContainer.defaultProps = {
  exclude: [],
  error: false,
  loading: false,
  hasProduct: true,
  newProductMessage: null,
  newProductAction: null,
  banner: null,
  mercury: null,
};

export default ContentContainer;
